export const DAY_FILTERS = [
    { key: 'M', label: 'Mon' },
    { key: 'T', label: 'Tue' },
    { key: 'W', label: 'Wed' },
    { key: 'R', label: 'Thu' },
    { key: 'F', label: 'Fri' },
];

export const TIME_OF_DAY_FILTERS = [
    { key: 'morning', label: 'Morning' },
    { key: 'afternoon', label: 'Afternoon' },
    { key: 'evening', label: 'Evening' },
];

const DAY_NAMES = [
    ['M', /\bmon/i],
    ['T', /\btue/i],
    ['W', /\bwed/i],
    ['R', /\bthu/i],
    ['F', /\bfri/i],
    ['S', /\bsat/i],
    ['U', /\bsun/i],
];

/**
 * The days a meeting's `days` text names as day keys (M T W R F S U). Registrar
 * patterns ("MWF", "TR") are letters, R being Thursday; free text ("Tuesdays",
 * "Mon/Wed") is read by day name. Text that names no day gives none.
 */
export function meetingDayKeys(days) {
    const text = String(days ?? '').trim();
    if (/^[MTWRFSU]+$/.test(text)) return [...new Set(text)];
    return DAY_NAMES.filter(([, pattern]) => pattern.test(text)).map(
        ([key]) => key
    );
}

/** Minutes after midnight at which a time such as "9:00 AM - 9:50 AM" starts, or null. */
export function meetingStartMinutes(time) {
    const match =
        /^(\d{1,2}):(\d{2})\s*(AM|PM)?(?:\s*(?:-|–|to)\s*\d{1,2}:\d{2}\s*(AM|PM)?)?/i.exec(
            String(time ?? '').trim()
        );
    if (!match) return null;
    let hour = Number(match[1]) % 12;
    const meridiem = (match[3] || match[4] || '').toUpperCase();
    if (!match[3] && !match[4]) hour = Number(match[1]);
    else if (meridiem === 'PM') hour += 12;
    return hour * 60 + Number(match[2]);
}

export function timeOfDayOf(minutes) {
    if (minutes === null || minutes === undefined) return null;
    if (minutes < 12 * 60) return 'morning';
    if (minutes < 17 * 60) return 'afternoon';
    return 'evening';
}

const timed = (position) =>
    (position?.meetings || []).filter((m) => m.days || m.time);

/** Whether any meeting falls on one of the chosen days. A position with no days set matches none. */
export function matchesDays(position, dayKeys) {
    if (!dayKeys.length) return true;
    return timed(position).some((m) =>
        meetingDayKeys(m.days).some((key) => dayKeys.includes(key))
    );
}

/** Whether any meeting starts in the chosen part of the day. */
export function matchesTimeOfDay(position, timeOfDay) {
    if (!timeOfDay) return true;
    return timed(position).some(
        (m) => timeOfDayOf(meetingStartMinutes(m.time)) === timeOfDay
    );
}

/** `in_person` also takes hybrid, which meets on campus part of the time. */
export function matchesModality(position, modality) {
    if (!modality) return true;
    if (modality === 'online') return position?.modality === 'online';
    return ['in_person', 'hybrid'].includes(position?.modality);
}
